module.exports = __webpack_public_path__ + "static/img/brees-2002-top.bbf6be5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2002-top.jpg
// module id = hvCU
// module chunks = 1